import { RowScaffold, ScaffoldSelection } from "../../interface";
import { buildRowRange } from "./buildRowRange";

/**
 * Adds a row range to the existing selection without removing other selections.
 *
 * @param selection - The current scaffold selection state.
 * @param rows - All available scaffold rows.
 * @param anchorRowId - The row ID of the selection anchor.
 * @param targetRowId - The row ID of the target row.
 * @returns A new selection state with the row range merged in.
 */
export const addRowRangeToSelection = <T>(
  selection: ScaffoldSelection,
  rows: RowScaffold<T>[],
  anchorRowId: string,
  targetRowId: string,
): ScaffoldSelection => {
  const rangeItems = buildRowRange(rows, anchorRowId, targetRowId);
  const existingIds = new Set(selection.selectedRows.map((r) => r.firstCellId));
  const newItems = rangeItems.filter((r) => !existingIds.has(r.firstCellId));

  return {
    ...selection,
    selectedRows: [...selection.selectedRows, ...newItems],
  };
};
